import { createFileRoute } from '@tanstack/react-router'
import { useState } from 'react'
import z from 'zod'

import type { CallRecord } from '@/models'
import { Authentication } from '@/rbac'
import CallRecordEdit from '@/routes/arc/-features/call-records/CallRecordEdit.tsx'
import PaginateCallRecords from '@/routes/arc/-features/call-records/PaginatedCallRecords.tsx'
import AdminStatisticsNav from '@/routes/arc/-widgets/admin-statistics-nav/AdminStatisticsNav.tsx'

export const Route = createFileRoute('/arc/status/admin')({
  component: AdminPage,
  validateSearch: z.object({
    current: z.number().int().optional(),
    pageSize: z.number().int().optional(),
  }),
})

function AdminPage() {
  const [selectedCallLog, setSelectedCallLog] = useState<CallRecord | null>(null)
  const searchParams = Route.useSearch()
  const navigate = Route.useNavigate()

  return (
    <div className={'flex min-h-0 flex-1 flex-col'}>
      <AdminStatisticsNav />
      <section aria-labelledby="call-logs-heading" className={'flex min-h-0 flex-1 flex-col p-2.5'}>
        <h2 id="call-logs-heading" className="sr-only">
          Call Logs
        </h2>
        <div className={'flex min-h-0 flex-1 gap-2.5'}>
          <div className={'arc-card flex min-h-0 flex-1 flex-col overflow-x-auto'}>
            <Authentication require={['arc:call-log:list']} failMode={'empty'}>
              <PaginateCallRecords
                selected={selectedCallLog}
                onSelect={setSelectedCallLog}
                searchParams={{
                  current: searchParams.current ?? 1,
                  pageSize: searchParams.pageSize ?? 10,
                }}
                onPaginationChange={(current, pageSize) =>
                  navigate({
                    search: (old) => ({
                      ...old,
                      current,
                      pageSize,
                    }),
                  })
                }
              />
            </Authentication>
          </div>
          {selectedCallLog && <CallRecordEdit call={selectedCallLog} />}
        </div>
      </section>
    </div>
  )
}
